module.exports = __webpack_public_path__ + "9488d02b/img/dollar-icon.35c9d638.svg";